import React from "react";
import {
    Card,
    CardContent,
    Typography,
    Box,
    Stack,
    Grid,
} from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { nFormatter } from "../../../Helpers";
import DashboardCardInfo from "../../../Components/common/DashboardCardInfo";

const SalesTrendCard = ({
    title = "Sale Performance Trend",
    currentYearSale = 1000,
    lastYearSale = 5000,
    sparklineData,
    borderBottom = true,
    tooltipTitle
}) => {
    const percentAchieved = Math.abs((((currentYearSale -lastYearSale) /lastYearSale) *100)?.toFixed(1)) || 0

    const bottomStats = [
        { label: "Current Year", value: currentYearSale },
        { label: "Prior Year", value: lastYearSale }
    ];
    const isGrowth = currentYearSale >= lastYearSale;
    const lineColor = isGrowth ? "#4caf50" : "#f44336";
    const fillTop = isGrowth ? "rgba(168, 242, 170, 0.3)" : "rgba(255, 138, 128, 0.3)";
    const fillBottom = isGrowth ? "rgba(137, 244, 139, 0.78)" : "rgba(244, 67, 54, 0.7)";

    const chartData = sparklineData || [lastYearSale, currentYearSale];

    const sparklineOptions = {
        chart: {
            type: "area",
            backgroundColor: "transparent",
            height: 60,
            margin: [2, 0, 2, 0],
        },
        title: { text: undefined },
        credits: { enabled: false },
        xAxis: { visible: false },
        yAxis: { visible: false, endOnTick: false, startOnTick: false },
        legend: { enabled: false },
        tooltip: { enabled: false },
        plotOptions: {
            area: {
                marker: { enabled: false },
                lineWidth: 2,
                color: lineColor,
                fillColor: {
                    linearGradient: [0, 0, 0, 60],
                    stops: [
                        [0, fillTop],
                        [1, fillBottom],
                    ],
                },
            },
        },
        series: [{ type: "area", data: chartData }],
    };

    return (
        <Card elevation={0} sx={{
            borderRadius: 2,
            backgroundColor: "transparent",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between"
        }}>
            <CardContent sx={{
                px: 1,
                borderBottom: borderBottom ? "0.5px solid lightgray" : "none",
                "&:last-child": { pb: 1 },
                position: "relative",
                paddingBottom: "24px !important"
            }}>
                <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={12} sm={4} md={4}>
                        <Typography variant="body2" color="text.secondary">
                            {title} {isGrowth ? "↑" : "↓"}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} md={6}>
                        <HighchartsReact highcharts={Highcharts} options={sparklineOptions} />
                    </Grid>
                    <Grid item xs={12} sm={4} md={2}>
                        <Box textAlign={{ xs: "center", sm: "right" }}>
                            <Typography variant="h6" color={isGrowth ? "success.main" : "error.main"}>
                                {percentAchieved}%
                            </Typography>
                            {/* <Typography variant="caption" color="text.secondary">
                                Achieved
                            </Typography> */}
                        </Box>
                    </Grid>
                </Grid>

                {bottomStats?.length > 0 && (
                    <Box>
                        <Stack
                            direction={{ xs: "column", sm: "row" }}
                            justifyContent="space-between"
                            alignItems={{ xs: "center", sm: "flex-start" }}
                            spacing={{ xs: 1, sm: 0 }}
                        >
                            {bottomStats.map((stat, idx) => (
                                <Box key={idx} textAlign={{ xs: "center", sm: "left" }}>
                                    <Typography variant="subtitle2" color="text.secondary">
                                        {stat.label}
                                    </Typography>
                                    <Typography variant="body2" title={stat.value.toLocaleString()}>
                                        <strong>{nFormatter(stat.value, 2)} SAR</strong>
                                    </Typography>
                                </Box>
                            ))}
                        </Stack>
                    </Box>
                )}
                <DashboardCardInfo title={tooltipTitle} bottom={3} right={5}/>
            </CardContent>
        </Card>
    );
};



export default SalesTrendCard;
